module.exports = __webpack_public_path__ + "img/square.c0f0cec0.jpg";